enum ExerciseModalCloseHandle {
  OPEN_NEXT = 0,
  OPEN_PREV = 1,
}

export { ExerciseModalCloseHandle };
